import { useState } from 'react';
import './AdminPage.css';
import classNames from 'classnames';
import Overview from './Overview';
import Properties from './Properties';
import Logs from './Logs';

interface AdminPageProps {
  onLogout: () => void;
}

type Tab = 'overview' | 'properties' | 'logs';


function AdminPage({ onLogout }: AdminPageProps) {

  const [activeTab, setActiveTab] = useState<Tab>('overview');

  return (
    <div className="admin-page">
      <div className="header">
        <div className="title-box">
          <h1 className="page-title">Admin Page</h1>
          <button className="logout" onClick={onLogout}>Logout</button>
        </div>
        <div className="tabs">
          <button className={classNames('tab', {'active-tab': activeTab === 'overview'})} onClick={() => setActiveTab('overview')}>Overview</button>
          <button className={classNames('tab', {'active-tab': activeTab === 'properties'})} onClick={() => setActiveTab('properties')}>Properties</button>
          <button className={classNames('tab', {'active-tab': activeTab === 'logs'})}  onClick={() => setActiveTab('logs')}>Logs</button>
        </div>
      </div>
      <div className="content">
        {activeTab === 'overview' && <Overview />}
        {activeTab === 'properties' && <Properties />}
        {activeTab === 'logs' && <Logs />}  
      </div>
    </div>
  );

}

export default AdminPage;

